import { cn } from '../../utils';
import { useTheme } from '../../components/providers/theme-provider';

interface SharpeLogoProps {
  /** Controls the height in px; width scales to preserve the native aspect ratio */
  size?: number;
  className?: string;
}

export function SharpeLogo({ size = 28, className }: SharpeLogoProps) {
  const { resolvedTheme } = useTheme();
  const src = resolvedTheme === 'dark' ? '/logo-darkmode.svg' : '/logo-lightmode.svg';

  return (
    <img
      src={src}
      alt="Sharpe"
      className={cn('flex-shrink-0', className)}
      style={{ height: size, width: 'auto' }}
    />
  );
}
